import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper
} from '@mui/material';
import { useData } from '../../context/DataContext';
import DoctorCard from './DoctorCard';
import { useMarkPageReadyWithoutHero } from '../../context/PageReadyContext';

const Doctors = () => {
  useMarkPageReadyWithoutHero();
  const { state } = useData();
  const { doctors } = state;

  return (
    <Box>
      {/* Hero Section */}
      <Paper sx={{
        background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
        color: 'white',
        py: 8,
        textAlign: 'center'
      }}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Our Medical Team
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.9 }}>
            Meet our experienced and dedicated healthcare professionals
          </Typography>
        </Container>
      </Paper>

      {/* Doctors Grid */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom textAlign="center" sx={{ mb: 6 }}>
          Expert Physicians
        </Typography>
        <Grid container spacing={4}>
          {doctors.map((doctor) => (
            <Grid item xs={12} sm={6} md={4} key={doctor.id}>
              <DoctorCard 
                doctor={doctor}
                variant="default"
                showActions={true}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Why Choose Our Doctors */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom textAlign="center" sx={{ mb: 6 }}>
          Why Choose Our Medical Team?
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" component="div" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>
                50+
              </Typography>
              <Typography variant="h6" gutterBottom>
                Expert Doctors
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Board-certified physicians with extensive experience in their respective fields
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" component="div" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>
                15+
              </Typography>
              <Typography variant="h6" gutterBottom>
                Medical Specialties
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Comprehensive range of medical specialties to meet all your healthcare needs
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" component="div" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>
                10+
              </Typography>
              <Typography variant="h6" gutterBottom>
                Years Average Experience
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Our doctors bring years of clinical experience and expertise to every patient interaction
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" component="div" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>
                24/7
              </Typography>
              <Typography variant="h6" gutterBottom>
                Availability
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Round-the-clock medical care with emergency services always available
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Call to Action */}
      <Box sx={{ bgcolor: '#1976d2', color: 'white', py: 8 }}>
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" component="h2" gutterBottom>
            Schedule an Appointment
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
            Ready to meet with one of our expert doctors?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Call us at (051) 4252008 or email info@hih.com.pk
          </Typography>
          <Typography variant="body1">
            Our scheduling team will help you find the right doctor for your needs
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Doctors; 